import styled from 'styled-components';

export const ButtonsContainer = styled.div`
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 10;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px;

  background: rgba(255, 255, 255, 0.85);
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
`;

export const ViewerButton = styled.button`
  all: unset;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #ddd;
  font-size: 14px;
  font-weight: bold;
  color: #333;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #f5f5f5;
  }
`;
